import React from 'react';
import { MessageSquare, Zap, Brain } from 'lucide-react';
import { Card } from '@/components/ui/card';

const WhyAIPlugins = () => {
  const benefits = [
    {
      icon: MessageSquare,
      title: 'Smarter Websites',
      description: 'AI-powered chatbots, automated customer support, and intelligent user interactions that enhance visitor engagement.',
      color: 'from-blue-500 to-cyan-500'
    },
    {
      icon: Zap,
      title: 'Faster Workflows',
      description: 'AI-driven content generation, SEO optimization, automated workflows, and time-saving automation tools.',
      color: 'from-purple-500 to-pink-500'
    },
    {
      icon: Brain,
      title: 'Custom Intelligence',
      description: 'Tailored AI models, custom logic implementation, and intelligent features designed specifically for your business needs.',
      color: 'from-gold to-primary'
    }
  ];

  return (
    <section className="py-20 bg-luxury-900">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 text-white">
            Why AI-Powered Plugins?
          </h2>
          <p className="text-lg text-white/70 max-w-3xl mx-auto">
            Transform your WordPress site with cutting-edge AI technology. Enhance functionality, automate tasks, and deliver personalized experiences that drive results.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {benefits.map((benefit, index) => (
            <Card
              key={index}
              className="bg-luxury-800 border-luxury-700 p-8 hover:border-gold/50 transition-all duration-300 hover:scale-105 group"
            >
              <div className={`w-16 h-16 rounded-xl bg-gradient-to-br ${benefit.color} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
                <benefit.icon className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold mb-4 text-white">
                {benefit.title}
              </h3>
              <p className="text-white/70 leading-relaxed">
                {benefit.description}
              </p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyAIPlugins;
